import React, { useRef } from 'react'
import { useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import banner_1 from "../Assets/images/banner_1.jpg";
import banner_2 from "../Assets/images/banner_2.jpg";
import banner_3 from "../Assets/images/banner_3.jpg";
import banner_4 from "../Assets/images/banner_4.jpg";
import Slider from 'react-slick';

function BannerSlider() {

  // const [index, setIndex] = useState(0);

  // const handleSelect = (selectedIndex) => {
  //   setIndex(selectedIndex);
  // };
  const sliderRef = useRef(null); 
  const [isPaused, setIsPaused] = useState(false);

  
	var settings = {
	dots: false,
	infinite: true,
	speed: 500,
	slidesToShow: 1,
	slidesToScroll: 1,
  autoplay: true, // Enable auto-scroll
  autoplaySpeed: 3000, // Set auto-scroll speed (3 seconds)
  pauseOnHover: false, // Pause on hover
	};

  const handlePausePlay = () => {
    if (isPaused) {
      sliderRef.current.slickPlay();
    } else {
      sliderRef.current.slickPause();
    }
    setIsPaused(!isPaused);
  };

  return (
    <>
<div className='bannerSliderMain'>
<Slider ref={sliderRef} {...settings}>
<img className="d-block w-100" src={banner_2} alt="First slide" />
<img className="d-block w-100" src={banner_1} alt="2nd slide" />
<img className="d-block w-100" src={banner_3} alt="3rd slide" />
<img className="d-block w-100" src={banner_4} alt="5th slide" />
</Slider>

<button className="slick-prev slick-arrow" onClick={() => sliderRef.current.slickPrev()}><i class="fa fa-angle-left" aria-hidden="true"></i></button>
		<button className="slick-next slick-arrow" onClick={() => sliderRef.current.slickNext()}><i class="fa fa-angle-right" aria-hidden="true"></i></button>

    <button className="slick-pause-play" onClick={handlePausePlay}>
          {isPaused ? (
            <i className="fa fa-play" aria-hidden="true"></i>
          ) : (
            <i className="fa fa-pause" aria-hidden="true"></i>
          )}
        </button>

</div>



    </>
  )
}

export default BannerSlider